import { Link } from "react-router-dom";
import { Mail, MapPin, Linkedin } from "lucide-react";
import { Logo } from "@/components/Logo";

export const Footer = ({ theme = "dark", tagline, rights, location, backLink }) => {
  const isOcean = theme === "ocean";
  return (
    <footer
      className={`relative px-6 md:px-12 lg:px-20 py-16 border-t ${isOcean ? "border-white/10 bg-ocean-deep" : "border-white/10 bg-ink"}`}
      data-testid="site-footer"
    >
      <div className="flex flex-col md:flex-row justify-between gap-10 mb-12">
        <div className="max-w-sm">
          <Logo />
          <p className="font-manrope text-sm text-white/45 mt-4 leading-relaxed">{tagline}</p>
        </div>
        <div className="flex flex-col gap-3">
          {location && (
            <span className="flex items-center gap-2 font-manrope text-sm text-white/50">
              <MapPin className="w-4 h-4" /> {location}
            </span>
          )}
          <a
            href="mailto:hello@polvo.pt"
            data-testid="footer-email-link"
            className="flex items-center gap-2 font-manrope text-sm text-white/50 hover:text-brand-cyan transition-colors duration-300"
          >
            <Mail className="w-4 h-4" /> hello@polvo.pt
          </a>
          <a
            href="#"
            data-testid="footer-linkedin-link"
            className="flex items-center gap-2 font-manrope text-sm text-white/50 hover:text-brand-cyan transition-colors duration-300"
          >
            <Linkedin className="w-4 h-4" /> LinkedIn
          </a>
          {backLink && (
            <Link
              to={backLink.to}
              data-testid="footer-back-link"
              className="font-manrope text-sm text-white/50 hover:text-brand-cyan transition-colors duration-300"
            >
              {backLink.label}
            </Link>
          )}
        </div>
      </div>
      <p className="font-mono text-xs text-white/30 tracking-wide">{rights}</p>
    </footer>
  );
};
